var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticStyle: { "margin-top": "1vh" },
          attrs: {
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            width: "1200px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "title", attrs: { slot: "title" }, slot: "title" },
            [_vm._v("客户联系统计")]
          ),
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "商品统计", name: "goods" } },
                [
                  _c("div", { staticClass: "table-container" }, [
                    _c(
                      "div",
                      { staticClass: "btn-wrap" },
                      [
                        _c("el-input", {
                          staticStyle: {
                            width: "200px",
                            "margin-right": "10px"
                          },
                          attrs: {
                            size: "mini",
                            placeholder: "商品名称",
                            clearable: ""
                          },
                          on: {
                            clear: _vm.getTableData1,
                            blur: _vm.getTableData1
                          },
                          model: {
                            value: _vm.table1Params.chatName,
                            callback: function($$v) {
                              _vm.$set(_vm.table1Params, "chatName", $$v)
                            },
                            expression: "table1Params.chatName"
                          }
                        }),
                        _c("el-date-picker", {
                          staticStyle: { width: "240px" },
                          attrs: {
                            size: "mini",
                            editable: false,
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                            "range-separator": "-",
                            "start-placeholder": "发送开始时间",
                            "end-placeholder": "发送结束时间",
                            "picker-options": _vm.pickerOptions,
                            clearable: ""
                          },
                          on: { change: _vm.selectTime1 },
                          model: {
                            value: _vm.searchSelectTime1,
                            callback: function($$v) {
                              _vm.searchSelectTime1 = $$v
                            },
                            expression: "searchSelectTime1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "table-data" },
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loading1,
                                expression: "loading1"
                              }
                            ],
                            ref: "singleTable",
                            staticStyle: {
                              width: "100%",
                              height: "100%",
                              "font-size": "13px"
                            },
                            attrs: {
                              size: "medium",
                              "header-cell-style": {
                                background: "#eef1f6",
                                color: "#606266"
                              },
                              "highlight-current-row": true,
                              data: _vm.tableData1,
                              "default-sort": {
                                prop: "shareNumber",
                                order: "descending"
                              },
                              height: "308px"
                            },
                            on: { "sort-change": _vm.customerSortChange1 }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": "",
                                prop: "name",
                                label: "商品名称",
                                width: "118",
                                align: "left"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "shareNumber",
                                label: "发送次数",
                                sortable: "custom",
                                "min-width": "102",
                                align: "center"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "shareOpenNumber",
                                label: "点击次数",
                                sortable: "custom",
                                "min-width": "102",
                                align: "center"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "openRate",
                                label: "打开率",
                                sortable: "custom",
                                "min-width": "144",
                                align: "center"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "shelvesOrderNumber",
                                label: "商品成交量",
                                sortable: "custom",
                                "min-width": "102",
                                align: "center"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "orderRate",
                                label: "商品成交率",
                                sortable: "custom",
                                "min-width": "102",
                                align: "center"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "staff-pagination" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.table1Params.page,
                            "page-size": _vm.table1Params.size,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.total1,
                            "page-sizes": [20, 50, 100, 200, 500]
                          },
                          on: {
                            "current-change": _vm.getTableData1,
                            "size-change": _vm.getTableData1,
                            "update:currentPage": function($event) {
                              return _vm.$set(_vm.table1Params, "page", $event)
                            },
                            "update:current-page": function($event) {
                              return _vm.$set(_vm.table1Params, "page", $event)
                            },
                            "update:pageSize": function($event) {
                              return _vm.$set(_vm.table1Params, "size", $event)
                            },
                            "update:page-size": function($event) {
                              return _vm.$set(_vm.table1Params, "size", $event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c("el-tab-pane", { attrs: { label: "活动统计", name: "act" } }, [
                _c("div", { staticClass: "table-container" }, [
                  _c(
                    "div",
                    { staticClass: "btn-wrap" },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px", "margin-right": "10px" },
                        attrs: {
                          size: "mini",
                          placeholder: "活动名称",
                          clearable: ""
                        },
                        on: {
                          clear: _vm.getTableData2,
                          blur: _vm.getTableData2
                        },
                        model: {
                          value: _vm.table2Params.chatName,
                          callback: function($$v) {
                            _vm.$set(_vm.table2Params, "chatName", $$v)
                          },
                          expression: "table2Params.chatName"
                        }
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "240px" },
                        attrs: {
                          size: "mini",
                          editable: false,
                          type: "daterange",
                          "value-format": "yyyy-MM-dd",
                          "range-separator": "-",
                          "start-placeholder": "发送开始时间",
                          "end-placeholder": "发送结束时间",
                          "picker-options": _vm.pickerOptions,
                          clearable: ""
                        },
                        on: { change: _vm.selectTime2 },
                        model: {
                          value: _vm.searchSelectTime2,
                          callback: function($$v) {
                            _vm.searchSelectTime2 = $$v
                          },
                          expression: "searchSelectTime2"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "table-data" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading2,
                              expression: "loading2"
                            }
                          ],
                          ref: "singleTable",
                          staticStyle: {
                            width: "100%",
                            height: "100%",
                            "font-size": "13px"
                          },
                          attrs: {
                            size: "medium",
                            "header-cell-style": {
                              background: "#eef1f6",
                              color: "#606266"
                            },
                            "highlight-current-row": true,
                            data: _vm.tableData2,
                            "default-sort": {
                              prop: "shareNumber",
                              order: "descending"
                            },
                            height: "308px"
                          },
                          on: { "sort-change": _vm.customerSortChange2 }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "name",
                              label: "商品名称",
                              width: "118",
                              align: "left"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "shareNumber",
                              label: "发送次数",
                              sortable: "custom",
                              "min-width": "102",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "shareOpenNumber",
                              label: "点击次数",
                              sortable: "custom",
                              "min-width": "102",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "openRate",
                              label: "打开率",
                              sortable: "custom",
                              "min-width": "144",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "shelvesOrderNumber",
                              label: "商品成交量",
                              sortable: "custom",
                              "min-width": "102",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "orderRate",
                              label: "商品成交率",
                              sortable: "custom",
                              "min-width": "102",
                              align: "center"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "staff-pagination" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.table2Params.page,
                          "page-size": _vm.table2Params.size,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _vm.total2,
                          "page-sizes": [20, 50, 100, 200, 500]
                        },
                        on: {
                          "current-change": _vm.getTableData2,
                          "size-change": _vm.getTableData2,
                          "update:currentPage": function($event) {
                            return _vm.$set(_vm.table2Params, "page", $event)
                          },
                          "update:current-page": function($event) {
                            return _vm.$set(_vm.table2Params, "page", $event)
                          },
                          "update:pageSize": function($event) {
                            return _vm.$set(_vm.table2Params, "size", $event)
                          },
                          "update:page-size": function($event) {
                            return _vm.$set(_vm.table2Params, "size", $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }